import * as yup from "yup";

export const providerSchema = yup.object().shape({
  id: yup.string().required().uuid(),
  enabled: yup.bool().required(),
  customerId: yup.string().required().uuid(),
  name: yup.string().required().min(3),
  logo: yup.string().nullable().min(100),
});

export const npayexProviderSchema = yup.object().shape({
  config: yup.object().shape({
    baseUrl: yup.string().label("baseUrl").required(),
    apiKey: yup.string().label("apiKey").required(),
  }),
  overrideConfig: yup.object().shape({
    baseUrl: yup.string().label("baseUrl}"),
    apiKey: yup.string().label("apiKey"),
  }),
});
